<template>
  <div>
      <div class="page-header">
          <img src="../assets/关于我们.webp"/>
          <div class="page-header-content">
              <div style="font-weight: 500;font-size: 48px;color: rgba(51, 51, 51, 1);font-style: normal;letter-spacing: 4px;line-height: 66px;text-decoration: none;">关于我们</div>
          </div>
      </div>
      
      
      
      <!-- 关于我们-->
      <div class="about_me head-label">
          <div style="text-align: center; margin-bottom: 20px;" class="font_size_24">
            公司简介
          </div>

          <div class="intro-desc ">我们是一家专注于整合并优化本地信息分类的互联网服务平台，致力于打造一个集便捷性、全面性与精准性于一体的综合性信息平台。自成立以来，我们始终秉承"连接每一刻生活，让信息触手可及"的愿景，通过先进的数据处理技术和人性化的用户体验设计，为广大用户提供涵盖餐饮美食、休闲娱乐、生活服务、房产租售、求职招聘等多领域的本地化信息服务。</div>
          <!-- <div class="intro-desc ">公司愿景：成为全球领先的教育服务提供商，让每个孩子都能享受到优质、公平的教育资源。</div>
          <div class="intro-desc ">公司使命：以科技赋能教育，以爱心培育未来，为学生创造无限可能。</div>
          <div class="intro-desc ">核心价值观：创新、责任、卓越、共赢。我们鼓励创新思维，勇于担当责任，追求卓越品质，实现合作共赢。</div> -->

          <div class="course-imgs">
            <div class="course-img">
                  <img src="../assets/us-1.webp"/>
              </div>
              <div class="course-img">
                    <img src="../assets/us-2.webp"/>
                </div>
          </div>
      </div>

      <div class="about_me head-label">
          <div style="text-align: center; margin-bottom: 20px;" class="font_size_24">
            品牌理念
          </div>

          <div class="course-mind-content" style="align-items: start;"> 
            <div class="course-img">
                <img src="../assets/us-3.webp"/>
            </div>
            <div class="course-mind">
                <div>品牌理念：精准连接，服务至上</div>
                <div>我们相信，优质的服务始于精准的连接。因此，我们致力于构建一座桥梁，精准对接用户需求与商家服务，让每一次点击都能转化为满意的结果。</div>
                <div>信息透明，诚信为本</div>
                <div>在信息繁杂的网络世界中，我们坚持信息透明化原则，对每一条信息进行严格审核，确保真实可靠，营造诚信为本的网络环境。</div>
                <div>智能推荐，个性化体验：</div>
                <div>利用大数据与人工智能技术，我们为每位用户量身定制信息推送，让每一次浏览都成为一次个性化的探索之旅，提升用户的使用体验与满意度。</div>
            </div>
            </div>
            

      </div>

  </div>
</template>
<script>
  export default {
      name: 'About'
  }
</script>

<style scoped>
 

  .about_me {
      margin: 100px 20vw 50px;
  }

  .font_size_24 {
      font-size: 1.5em;
  }

  .intro-desc {
    margin-bottom: 5px;
    font-weight: 400;
    font-size: 14px;
    color: rgb(85, 85, 85);
    font-style: normal;
    letter-spacing: 0px;
    line-height: 32px;
    text-decoration: none;
  }

  .course-imgs {
    margin: 60px 0 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .course-imgs > div {
    width: 48%;
  }

  .course-img img {
    width: 100%;
  }

  .course-imgs > div > img {
    width: 100%;
  }

  .course-mind-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .course-mind-content > div {
    width: 48%;
  }
  .course-mind {
    
    padding: 0 3vw;
    box-sizing: border-box;
  }



  .course-mind > div:nth-child(2n -1) {
    margin-top: 10px;
    position: relative;
    font-weight: 700;
    font-size: 16px;
    color: rgb(85, 85, 85);
    font-style: normal;
    letter-spacing: 0px;
    line-height: 32px;
    text-decoration: none;
  }

  .course-mind > div:nth-child(2n -1):before {
    content: '';
    position: absolute;
    left: -15px;
    top: 13px;
    width: 6px;
    height: 6px;
    border-radius: 6px;
    background: rgb(85, 85, 85);
  }

  .course-mind > div:nth-child(2n) {
    font-weight: 400;
    font-size: 14px;
    color: rgb(85, 85, 85);
    font-style: normal;
    letter-spacing: 0px;
    text-decoration: none;
  }
  
</style>